import React, { useEffect, useState } from 'react'
import { APP_NAME } from 'configs/AppConfig';
import Flex from 'components/shared-components/Flex';
import { Button, Dropdown, Menu, Form, Input, Popover, Upload, Alert, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {FaFacebookF,FaTwitter,FaInstagram,FaYoutube} from 'react-icons/fa'
import {
    showLoading,
    showAuthMessage,
    hideAuthMessage
} from 'redux/actions/Auth';
import { motion } from 'framer-motion';
import { connect } from 'react-redux';
import AppService from "services/AppService";


 function Footer(props) {
	const { showMessage, message, hideAuthMessage, showAuthMessage } = props
	const [form]=Form.useForm()
	const [fileList, setFilelist] = useState([])
	const options = {
		// onRemove: file => {
		//     console.log(filelist)
		//     const index = filelist.indexOf(file)
		//     const newFileList = filelist.slice()
		//     newFileList.splice(index, 1)
		//     console.log(newFileList)
		//     setFilelist(newFileList)
		// },
		// previewFile:(file)=>{
		//    console.log(file)
		// },
		beforeUpload: async file => {

			// let src = await new Promise(resolve => {
			//     const reader = new FileReader();
			//     reader.readAsDataURL(file.originFileObj)
			//     reader.onload = () => resolve(reader.result);
			// })



			return false
		},
		onChange: async ({ fileList: newFileList }) => {
			// console.log(fileList)
			if (newFileList.length > 3) {
				showAuthMessage("You can not upload more than 3 images.")
			} else {
				setFilelist(newFileList)
			}

			// const temp = newFileList

			// let file = newFileList[newFileList.length - 1]
			// // console.log(file)
			// if (file) {
			// 	let src = await new Promise(resolve => {
			// 		const reader = new FileReader();
			// 		reader.readAsDataURL(file.originFileObj);
			// 		reader.onload = () => resolve(reader.result);
			// 	});
			// 	const image = new Image();

			// 	image.src = src
			// 	// console.log(image,src)
			// 	// console.log(image.width,image.height)
			// 	// image.onload = function () {
			// 	//     if (image.width !== 100 && image.height !== 100) {
			// 	//         showAuthMessage(
			// 	//             "Image dimension must be 100 x 100 px."
			// 	//         )
			// 	//     } else {
			// 	setFilelist(temp);
			// 	//     }

			// 	// }


			// } else {
			// 	setFilelist(temp);
			// }



		},

		onPreview: async file => {
			let src = file.url;
			if (!src) {
				src = await new Promise(resolve => {
					const reader = new FileReader();
					reader.readAsDataURL(file.originFileObj);
					reader.onload = () => resolve(reader.result);
				});
			}
			const image = new Image();
			image.src = src;
			const imgWindow = window.open(src);
			imgWindow.document.write(image.outerHTML);
		}
	}
	const onFinish=(values)=>{
		// console.log(values)
       var formData= new FormData()
	   formData.append('name',values?.name)
	   formData.append('title',values?.title)
	   formData.append('issue',values?.issue)
	   fileList.forEach(file=> formData.append('screenshots',file.originFileObj))
	   AppService.reportBug(formData).then(resp=>{
		   notification.success({
			   message:"Bug reported successfully"
		   })
		   form.resetFields()
		   setFilelist([])
	   }).catch(e=>showAuthMessage(e.response.data))
	
	}
	const reportForm = (
		<div className="footer-form" >
			<Form form={form} onFinish={onFinish}>
				<Form.Item label="Name" name='name' rules={[{ required: true }]}>
					<Input></Input>

				</Form.Item>
				<Form.Item label="Title" name='title' rules={[{ required: true }]}>
					<Input></Input>

				</Form.Item>
				<Form.Item label="Issue" name='issue' rules={[{ required: true }]}>
					<Input.TextArea style={{ height: 100 }} ></Input.TextArea>

				</Form.Item>
				<Form.Item
					name="screenshots"
					label="Upload"
					
					extra="Upload screenshots of bugs"
				>

					<Upload multiple {...options} listType='picture' fileList={fileList}  accept='.jpg,.jpeg,.png' >

						<Button>
							<UploadOutlined />  <span className='ml-2'>upload</span>
						</Button>

					</Upload>
				</Form.Item>
				<motion.div
					initial={{ opacity: 0, marginBottom: 0 }}
					animate={{
						opacity: showMessage ? 1 : 0,
						marginBottom: showMessage ? 20 : 0
					}}>
					<Alert type="error" showIcon message={message}></Alert>
				</motion.div>

				<Form.Item>
					<Button type='primary'  htmlType="submit">
						Submit
					</Button>
				</Form.Item>
			</Form>

		</div>



	)
	useEffect(() => {
		if (showMessage) {
			setTimeout(() => {
				hideAuthMessage()
			}, 3000)
		}
	})
	return (
		<footer className="footer">
			{/* <Flex justifyContent='between' alignItems='center' className='w-100' mobileFlex={false}>
				<div> <span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights reserved.</span></div>

				<Popover placement="topRight" title="Report bug" content={reportForm} trigger="click">
					<Button className='report-btn'>Report bug</Button>

				</Popover>
			</Flex> */}
			<div className='container'>
             <Flex className='footer-top' justifyContent='between' mobileFlex={false}>
				 <Flex className='footer-top-left' justifyContent='center' alignItems='center' mobileFlex={false}>
					 <figure className='footer-logo'>
                        <img src='/img/One-ATS.svg'></img>
					 </figure>
					 <p className='tag-line capitalized'>Simplifying recruitment lifecycle</p>
				 </Flex>
				 <Flex className='footer-top-right' alignItems='center' justifyContent='center' mobileFlex={false}>
				 	 <h3 className='follow-us-text capitalized'>Follow us On</h3>	 
					 <ul className='social-links'>
                       <li className='social-link'>
						   <a href='#'><FaFacebookF/></a>
					   </li>
					   <li className='social-link'>
						   <a href='#'><FaTwitter/></a>
					   </li>
					   <li className='social-link'>
						   <a href='#'><FaInstagram/></a>
					   </li>
					   <li className='social-link'>
						   <a href='#'><FaYoutube/></a>
					   </li>
					 </ul>

				</Flex>	 
			 </Flex>
			 <div className='footer-bottom'>
                 <Flex justifyContent='center' alignItems='center'>
					 
					 <ul className='footer-links'>
						 <li>
							 <a href='/app/privacy-policy' className='capitalized'>Privacy policy</a>
						 </li>
						 <li>
							 <a href='/app/terms-conditions' className='capitalized'>Terms & Conditions</a>
						 </li>
					 </ul>
				 </Flex>
				 <p className='footer-bottom-text '>
				 One ATS helps you manage your recruiting and hiring process, including job postings and job applications.
				 </p>
			 </div>

			</div>

		</footer>
	)
}

const mapStateToProps = ({ auth }) => {
    const { loading, message, showMessage } = auth
    return { loading, message, showMessage }
}
const mapDispatchToProps = {
    showAuthMessage,
    showLoading,
    hideAuthMessage
}


export default connect(mapStateToProps, mapDispatchToProps)(Footer)